import { openModal } from "./utils"

export default function (message: string) {
  const confirmModalEl = document.getElementById("confirm-dialog") as HTMLElement
  const confirmButton = document.getElementById("confirm-dialog-btn") as HTMLButtonElement
  document.getElementById("confirm-dialog-message").innerText = message

  return new Promise((resolve, reject) => {
    const modal = openModal(confirmModalEl)
    let result = false

    const confirmHandler = () => {
      result = true
      modal.hide()
    }
    confirmButton.addEventListener("click", confirmHandler)

    const hiddenHandler = () => {
      confirmButton.removeEventListener("click", confirmHandler)
      confirmModalEl.removeEventListener("hidden.bs.modal", hiddenHandler)
      resolve(result)
    }
    confirmModalEl.addEventListener("hidden.bs.modal", hiddenHandler)
  })
}
